import "./CommandCenter.module.css";
import EduSproutHeader from "@/reusable_sections/Header";
import TheSrdStandard from "./sections/TheSrdStandard";
import TheRevenueLeakageReality from "./sections/TheRevenueLeakageReality";
import OurRemodelingStory from "./sections/OurRemodelingStory";
import OurCapabilities from "./sections/OurCapabilities";
import AreYouABestFit from "./sections/AreYouABestFit";
import InitiateYourChinaOperation from "./sections/InitiateYourChinaOperation";
import PolarizationFilter from "./sections/PolarizationFilter";
import PlatformFooter from "@/reusable_sections/Footer";
export default function CommandCenterPage() {
  return <div>
      <EduSproutHeader />
      <TheSrdStandard />
      <TheRevenueLeakageReality />
      <OurRemodelingStory />
      <PolarizationFilter />
      <OurCapabilities />
      <AreYouABestFit />
      <InitiateYourChinaOperation />
      <PlatformFooter />
    </div>;
}